import { Injectable, effect, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { AtomTimepickerIntl } from "@atomchat-io/ui-design-system";
import { TranslocoService } from "@jsverse/transloco";
import { take } from "rxjs";

/**
 * Localizes the `atom-time-picker` labels (toggle aria-labels + input
 * placeholders) through Transloco. Extends `AtomTimepickerIntl` and re-emits
 * `changes` so mounted pickers refresh their labels on every language change.
 */
@Injectable({
    providedIn: "root",
})
export class AtomTimepickerIntlService extends AtomTimepickerIntl {
    private readonly translocoService = inject(TranslocoService);
    private readonly activeLang = toSignal(this.translocoService.langChanges$);

    constructor() {
        super();
        effect(() => {
            this.activeLang();
            this.updateLabels();
        });
    }

    private updateLabels(): void {
        this.translocoService
            .selectTranslateObject("atom_time_picker")
            .pipe(take(1))
            .subscribe((data) => {
                this.openTimePickerLabel = data.open_time_picker_label;
                this.closeTimePickerLabel = data.close_time_picker_label;
                this.inputPlaceholder = data.input_placeholder;
                this.inputPlaceholder24h = data.input_placeholder_24h;
                this.changes.next();
            });
    }
}
